import { keyBy } from 'lodash';
import { Channel, IChannelFromBE } from 'messaging/types/messages';
import { sortChannelsByLastActivity } from '.';
import { ChannelsMap } from 'messaging/types/redux/messagingState';

export default function generateChannelsMap(channels?: IChannelFromBE[]) {
    if (!channels) {
        return {};
    }

    return keyBy(sortChannelsByLastActivity(channels), 'channelId');
}

const generateChannel = (channel: IChannelFromBE): Channel => {
    return {
        id: channel.channelId,
        name: channel.channelType === 'service_request' ? channel.serviceRequestData?.title : '',
        messages: [],
        lastMessage: channel.lastMessage || '',
        lastMessageTimestamp: Number(channel.lastActivity),
        hasUnread: false,
        viewed: Number(channel.lastActivity),
    };
};

export const generateChannelsFromMap = (channelsMap: ChannelsMap) =>
    Object.entries(channelsMap as { [id: string]: IChannelFromBE }).reduce((acc, [id, channel]) => {
        return {
            ...acc,
            [id]: generateChannel(channel),
        };
    }, {});
